
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const ItemTypesManagementForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "koha.item_types_management",
    parentItemTypesOptions,
    parentLibraryOptions,
    parentAuthorisedValuesOptions,

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        if (!parentItemTypesOptions) {
            itemTypesController.getData({})
            libraryController.getData({})
            authorisedValuesController.getData({
                category: "ITEMTYPECAT"
            })
        }
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const itemTypesController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const authorisedValuesController = useCRUDController({ apiRoute: "/koha/authorised_values" })
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                parentItemTypesOptions={parentItemTypesOptions ? parentItemTypesOptions : itemTypesController.ResponseData}
                                parentLibraryOptions={parentLibraryOptions ? parentLibraryOptions : libraryController.ResponseData}
                                parentAuthorisedValuesOptions={parentAuthorisedValuesOptions ? parentAuthorisedValuesOptions : authorisedValuesController.ResponseData}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "library",
    axiosMode,
    parentItemTypesOptions,
    parentLibraryOptions,
    parentAuthorisedValuesOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={8} >
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                {...field}
                                name={[field?.name ?? '', 'itemtype']}
                                fieldKey={[field?.fieldKey ?? '', 'itemtype']}
                                label={t('itemtype')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >
                                <Input maxLength={10} disabled={axiosMode === "patch"} />
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                {...field}
                                name={[field?.name ?? '', 'description']}
                                fieldKey={[field?.fieldKey ?? '', 'description']}
                                label={t('description')}
                                rules={[{ required: true, message: t('please_input_item') }]}
                            >

                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={8} >
                            <Form.Item
                                labelCol={6}
                                wrapperCol={18}
                                {...field}
                                name={[field?.name ?? '', 'parent_type']}
                                fieldKey={[field?.fieldKey ?? '', 'parent_type']}
                                label={t('parent_type')}
                            >
                                <Select
                                    allowClear={true}
                                    options={parentItemTypesOptions.map((value) => {
                                        return {
                                            ...value,
                                            label: `${value?.itemtype} ${value?.description}`,
                                            value: value?.itemtype
                                        }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        {/* <Col span={6} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'searchcategory']}
                                fieldKey={[field?.fieldKey ?? '', 'searchcategory']}
                                label={t('searchcategory')}
                                extra={t('options_defined_by_itemtypecat')}
                            >
                                <Select
                                    options={parentAuthorisedValuesOptions.map((value) => {
                                        return {
                                            ...value,
                                            label: `${value?.id} ${value?.description_opac}`,
                                            value: value?.description_opac
                                        }
                                    })}
                                />
                            </Form.Item>
                        </Col> */}


                    </Row>
                </Col>
                <Col span={12}>
                    <Row>


                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'hideinopac']}
                                fieldKey={[field?.fieldKey ?? '', 'hideinopac']}
                                label={t('hideinopac')}
                                extra={t('hide_in_opac_description')}
                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("open")}
                                    unCheckedChildren={t("close")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'notforloan']}
                                fieldKey={[field?.fieldKey ?? '', 'notforloan']}
                                label={t('notforloan')}
                                extra={t('no_issue_option')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("open")}
                                    unCheckedChildren={t("close")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'automatic_checkin']}
                                fieldKey={[field?.fieldKey ?? '', 'automatic_checkin']}
                                label={t('automatic_checkin')}
                                extra={t('automatic_checkin_option')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("open")}
                                    unCheckedChildren={t("close")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'rentalcharge']}
                                fieldKey={[field?.fieldKey ?? '', 'rentalcharge']}
                                label={t('rentalcharge')}
                                extra={t('checkout_renewal_fee')}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'rentalcharge_daily']}
                                fieldKey={[field?.fieldKey ?? '', 'rentalcharge_daily']}
                                label={t('rentalcharge_daily')}
                                extra={t('daily_fee_description')}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'rentalcharge_daily_calendar']}
                                fieldKey={[field?.fieldKey ?? '', 'rentalcharge_daily_calendar']}
                                label={t('rentalcharge_daily_calendar')}
                                extra={t('daily_charge_calendar_description')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("open")}
                                    unCheckedChildren={t("close")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'rentalcharge_hourly']}
                                fieldKey={[field?.fieldKey ?? '', 'rentalcharge_hourly']}
                                label={t('rentalcharge_hourly')}
                                extra={t('hourly_fee_description')}

                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'rentalcharge_hourly_calendar']}
                                fieldKey={[field?.fieldKey ?? '', 'rentalcharge_hourly_calendar']}
                                label={t('rentalcharge_hourly_calendar')}
                                extra={t('hourly_charge_calendar_description')}

                            >
                                <Switch
                                    mode='number'
                                    checkedChildren={t("open")}
                                    unCheckedChildren={t("close")}
                                />
                            </Form.Item>
                        </Col>


                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'defaultreplacecost']}
                                fieldKey={[field?.fieldKey ?? '', 'defaultreplacecost']}
                                label={t('defaultreplacecost')}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'processfee']}
                                fieldKey={[field?.fieldKey ?? '', 'processfee']}
                                label={t('processfee')}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'checkinmsgtype']}
                                fieldKey={[field?.fieldKey ?? '', 'checkinmsgtype']}
                                label={t('checkinmsgtype')}
                            >
                                <Select
                                    options={[
                                        {
                                            label: t('alert'),
                                            value: "alert"
                                        },
                                        {
                                            label: t('message'),
                                            value: "message"
                                        }
                                    ]}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'checkinmsg']}
                                fieldKey={[field?.fieldKey ?? '', 'checkinmsg']}
                                label={t('checkinmsg')}

                            >
                                <Textarea />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branches']}
                                fieldKey={[field?.fieldKey ?? '', 'branches']}
                                label={t('branches')}
                                extra={t('library_selection_description')}
                            >
                                <Select
                                    mode={"multiple"}
                                    options={[
                                        {
                                            label: t('all_select'),
                                            value: ""
                                        }
                                        , ...parentLibraryOptions?.map((value) => {
                                            return {
                                                ...value,
                                                label: `${value?.branchcode} ${value?.branchname}`,
                                                value: value?.branchcode
                                            }
                                        })]}
                                />
                            </Form.Item>
                        </Col>
                        {/* 目前沒有串上圖片上傳功能 */}
                        {/* <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'imageurl']}
                                fieldKey={[field?.fieldKey ?? '', 'imageurl']}
                                label={t('imageurl')}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'summary']}
                                fieldKey={[field?.fieldKey ?? '', 'summary']}
                                label={t('summary')}
                                extra={t('summary_override_description')}

                            >
                                <Textarea />
                            </Form.Item>
                        </Col>

                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'sip_media_type']}
                                fieldKey={[field?.fieldKey ?? '', 'sip_media_type']}
                                label={t('sip_media_type')}
                                hidden={true}
                            >
                                <Select
                                    options={[]}
                                />
                            </Form.Item>
                        </Col>



                    </Row>
                </Col>
            </Row>
        </>
    );
};





export default ItemTypesManagementForm;
